package com.bikompanion.ui.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.unit.dp

/**
 * An inverted-U bike stand on the ground. Drawn by hand, on the 960 grid and 80-unit stroke of the
 * Material Symbols it sits beside, because Material has no bike parking glyph of its own.
 */
val BikeRack: ImageVector
    get() {
        if (_BikeRack != null) return _BikeRack!!

        _BikeRack = ImageVector
            .Builder(
                name = "bike_rack",
                defaultWidth = 24.dp,
                defaultHeight = 24.dp,
                viewportWidth = 960f,
                viewportHeight = 960f,
            ).apply {
                addPath(
                    pathData = addPathNodes(
                        "M120,840L120,760L240,760L240,360A240,240 0 0 1 720,360L720,760L840,760L840,840Z" +
                            "M320,760L640,760L640,360A160,160 0 0 0 320,360Z",
                    ),
                    fill = SolidColor(Color.Black),
                )
            }.build()

        return _BikeRack!!
    }

private var _BikeRack: ImageVector? = null
